import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { mapSearchParamsToFilters } from '@trqk/utils';

interface UseUrlParamFiltersInput {
    /**
     * Callback invoked when filters are initially read from URL params and every time they change
     * afterwards
     */
    onFilterUpdate: (filters: URLParamFilter[], isInitialRead: boolean) => void;
    /**
     * List of {@link URLParamFilterInput} objects that dictate which URL parameters to read and
     * pass into onFilterUpdate as {@link URLParamFilter} objects
     */
    paramInputs: URLParamFilterInput[];
}

export const useUrlParamFilters = ({
    onFilterUpdate,
    paramInputs,
}: UseUrlParamFiltersInput): void => {
    const location = useLocation();
    const isInitialReadRef = useRef(true);

    useEffect(() => {
        // On initial load and whenever location.search changes, read URL params and invoke callback
        const searchParams = new URLSearchParams(location.search);
        const filterState = mapSearchParamsToFilters(searchParams, paramInputs);

        onFilterUpdate(filterState, isInitialReadRef.current ?? true);

        isInitialReadRef.current = false;
    }, [location.search, isInitialReadRef]);
};
